import React from "react";
import { Button } from "@/components/Button";
import {
  droppsProductToProductCardProduct,
  getDisplayDate,
} from "../../helpers";
import { ItemCard } from "../../SubProductCard";
import { BoxDrawerPageProps } from "../../RootBoxDrawer";
import { Card } from "@/components/Card";
import { useSelectedItemContext } from "../../SelectedItemContext";

type ConsolidateShipmentPageProps = BoxDrawerPageProps;

const ConsolidateShipmentPage = ({
  notify,
  onExit,
  box,
  nextChargeDate,
}: ConsolidateShipmentPageProps) => {
  const { rechargeItem } = useSelectedItemContext().boxItem;

  const currentShipDate = box
    ? box.nextChargeDate
    : rechargeItem.nextChargeDate;

  const ConsolidateShipment = () => {
    notify({
      title: "Ship Date Updated",
      message: `Items now shipping on ${getDisplayDate(nextChargeDate)}`,
    });
    onExit();
  };
  return (
    <>
      <div className="space-y-4">
        <h3 className="subtitle text-base font-semibold">Consolidate Items</h3>
        <p className="body text-sm">
          {box ? "The items below are" : "This item is"} currently shipping on:
        </p>
        <ul className="ml-5 text-sm">
          <li className="list-disc">{getDisplayDate(currentShipDate)}</li>
        </ul>
      </div>
      <div className="space-y-4">
        {box &&
          box.items.map((s) => {
            const { product, variant, rechargeItem } = s;
            const productCardProduct = droppsProductToProductCardProduct({
              product,
              variant,
            });
            return (
              <ItemCard
                key={product.id}
                product={productCardProduct}
                price={rechargeItem.price}
                quantity={rechargeItem.quantity}
                shippingInfo={rechargeItem.cadence ?? undefined}
              />
            );
          })}
      </div>
      <p className="body text-sm">
        To consolidate your items and have {box ? "these items" : "this item"}{" "}
        ship with your next box on the date below, click confirm.
      </p>
      <Card bordered>
        <>
          <h4 className="body text-sm">New ship date (ships with next box):</h4>
          <p className="body text-3xl font-semibold text-primary xl:text-2xl">
            {getDisplayDate(nextChargeDate)}
          </p>
        </>
      </Card>
      <div className="space-y-4">
        <Button className="w-full" onClick={ConsolidateShipment}>
          Confirm New Date
        </Button>
        <Button className="w-full" onClick={onExit} variant="outline">
          Cancel
        </Button>
      </div>
    </>
  );
};

export { ConsolidateShipmentPage };
